if (!customElements.get('product-options')) {
  class ProductOptions extends HTMLElement {

    selectedOptions = {};
    productId = '';
    clubName = '';
  
    constructor() {
      super();
    }

    connectedCallback() {
      this.productId = this.getAttribute('data-product-id');
      this.clubName = this.getAttribute('data-club-name') || '+';
      
      const idx = this.getAttribute('data-index');

      if (!this.productId) {
        console.error('ProductOptions component requires a data-product-id attribute.');
        return;
      }

      if (!idx) {
        this.classList.add('active');
      }
    
      document.addEventListener(`${this.productId}-variant-change`, (event) => {
        if (event.detail?.variantId) {
          this.classList.add('active');
        } else {
          this.classList.remove('active');
        }
      });
    
      const optionElements = this.querySelectorAll('.club-product-option');
      optionElements.forEach((optionElement) => {
        const handle = optionElement.getAttribute('data-product-option');
        const optionName = optionElement.getAttribute('data-option-name');
        const optionPrice = optionElement.getAttribute('data-value');

        if (!handle || !optionName) {
          return;
        }

        const checkbox = optionElement.querySelector(`#option-${this.productId}-${handle}`);
        const inputCustom = optionElement.querySelector(`#custom-${this.productId}-${handle}`);
        const optionCustomContainer = optionElement.querySelector('.option-custom');

        if (!checkbox) {
          return;
        }

        if (checkbox.checked) {
          this.selectedOptions[handle] = {
            name: checkbox.value,
            price: optionPrice || 0,
            description: optionName
          };
          document.dispatchEvent(new CustomEvent('update-product-options', { detail: { price: optionPrice || 0, id: `${this.productId}-${handle}` } }));
        }
      
        if (inputCustom) {
          const inputType = inputCustom.getAttribute('data-option-type');
          inputCustom.addEventListener('keydown', (event) => {
            if (inputType === 'number') {
              // Allow: backspace, delete, tab, escape, enter, period, and arrows
              if ([46, 8, 9, 27, 13, 110, 190].includes(event.keyCode) ||
                  // Allow: Ctrl/cmd+A
                  (event.keyCode === 65 && (event.ctrlKey || event.metaKey)) ||
                  // Allow: Ctrl/cmd+C
                  (event.keyCode === 67 && (event.ctrlKey || event.metaKey)) ||
                  // Allow: Ctrl/cmd+X
                  (event.keyCode === 88 && (event.ctrlKey || event.metaKey)) ||
                  // Allow: home, end, left, right
                  (event.keyCode >= 35 && event.keyCode <= 39)) {
                // let it happen, don't do anything
                return;
              }
              // Ensure that it is a number and stop the keypress
              if ((event.shiftKey || (event.keyCode < 48 || event.keyCode > 57)) && (event.keyCode < 96 || event.keyCode > 105)) {
                event.preventDefault();
              }
            }
          });

          inputCustom.addEventListener('input', (event) => {
            if (this.selectedOptions[handle]) {
              this.selectedOptions[handle].custom = event.target.value;
            }
            checkbox.value = event.target.value || this.clubName;
          });
        }
  
        checkbox.addEventListener('change', (event) => {
          if (event.target.checked) {
            this.selectedOptions[handle] = {
              name: checkbox.value,
              price: optionPrice || 0,
              description: optionName
            };
          } else {
            delete this.selectedOptions[handle];
          }

          if (inputCustom && optionCustomContainer) {
            if (event.target.checked) {
              optionCustomContainer.style.display = 'block';
              inputCustom.setAttribute('required', 'required');
              inputCustom.removeAttribute('disabled');
              if (inputCustom.type === 'hidden') {
                inputCustom.value = this.clubName;
              }
            } else {
              optionCustomContainer.style.display = 'none';
              inputCustom.removeAttribute('required');
              inputCustom.setAttribute('disabled', 'disabled');
            }
          }

          this.updateFields();
          document.dispatchEvent(new CustomEvent('update-product-options', { detail: { price: optionPrice || 0, id: `${this.productId}-${handle}` } }));
        });
      });

      this.updateFields();
    }

    updateFields() {
      const spo = this.querySelector(`#_spo_${this.productId}`);

      if (!spo) {
        return;
      }

      const spoHidden = [];

      for (const [handle, optionData] of Object.entries(this.selectedOptions)) {
        spoHidden.push(`${optionData.description}:${optionData.price}`);
      }

      spo.value = spoHidden.join(',');
    }
  }

  customElements.define('product-options', ProductOptions);
}
